import React from 'react';
import { createBrowserRouter, createMemoryRouter } from 'react-router';

import AppLayout from './AppLayout';
import { setRouter } from './history';


// A data router is required for useBlocker() (the replacement of <Prompt />).
// The application routes are declared with <Routes> inside PublicRoutes and
// PrivateRoutes, so the data router has a single splat route.
export const routes = [
  {
    path: '*',
    element: <AppLayout />,
  },
];

export const createAppRouter = (options = {}) => {
  const { memory = false, initialEntries } = options;
  const router = memory
    ? createMemoryRouter(routes, { initialEntries })
    : createBrowserRouter(routes);
  setRouter(router);
  return router;
};

const router = createAppRouter();

export default router;
